import React, { useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import "./traWhenFundSwitchRequired.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";
import NotFound from "../../atoms/NotFound";

const TRAWhenFundSwitchRequiredModal = (props) => {
  const { traFundSwitchFetching } = useSelector(
    (state) => state.traChangeWithFundSwitchReducer,
  );
  const dispatch = useDispatch();
  const { postTRAChangeWhenFundSwitchRequired } = bindActionCreators(
    actionCreators,
    dispatch,
  );
  const [error422, setError422] = useState(false);
  const submitRef = useRef(false);
  const handleContinue = () => {
    // Prevent multiple rapid clicks
    if (submitRef.current) {
      return;
    }

    submitRef.current = true;

    const accountId = props.fromSinglePotScreen
      ? 0
      : props.selectedMultiplePot
        ? props.selectedMultiplePot.accountId
        : 0;

    postTRAChangeWhenFundSwitchRequired(props.investorId, accountId, props.age)
      .then((data) => {
        const res = data?.data;

        //shared success case handler
        if (
          res?.memberTRAId &&
          res?.traUpdateStatus === "Submitted" &&
          res?.httpStatusCode === 200
        ) {
          setError422(false);
          props.setIsFundSwitchRequired(false);

          props.fromSinglePotScreen
            ? props.setShowUpdateTra(true)
            : props.setUpdateTra(true);

          return;
        }

        //shared failed case handler
        if (
          res?.memberTRAId &&
          res?.traUpdateStatus === "Failed" &&
          res?.httpStatusCode === 422
        ) {
          setError422(true);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        submitRef.current = false;
      });
  };
  return (
    <div className="traFundSwitchRequiredConfirmationModal ps-3">
      <Row>
        <Col>
          <div className="close">
            <Link to="">
              <Icons
                iconname="close-large"
                variant="icon-eighteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <div className="mt-3 content">
          Changing your Target Retirement Age will trigger a fund switch to
          align your investments with your selected retirement age.
        </div>
        <div className="mt-3 content">
          You won’t be able to make further investment changes for up to 5
          working days and you won’t be able to change your Target Retirement
          Age again until this process is complete.
        </div>
        <div className="mt-3 content">
          You’ll receive a notification once the fund switch has been carried
          out.
        </div>
        <div className="mt-3 content">Do you want to continue?</div>
      </Row>
      <Row className="container-button mt-4 mb-4 update-tra">
        <div className="d-flex justify-content-end">
          <div>
            <Buttons
              name="Cancel"
              className="secondary"
              variantname="icon-sixteen-px"
              handleClick={props.handleCloseButton}
            />
          </div>
          <div className="close-button">
            <Buttons
              className="primary"
              name="Continue"
              disabled={submitRef.current || traFundSwitchFetching}
              traFundSwitchFetching={traFundSwitchFetching}
              handleClick={handleContinue}
            />
          </div>
        </div>
      </Row>
      <Row className="me-2">{error422 ? <NotFound err="ERROR_422" /> : ""}</Row>
    </div>
  );
};

export default TRAWhenFundSwitchRequiredModal;
